import { ProductClicked } from "@/hooks/eventing/types/redventures.ecommerce.v1.ProductClicked";

type CustomDimension = {
  key: string;
  value: string;
};

export const createDimension = (
  key: string,
  value: string | number | boolean | undefined,
): CustomDimension | null => {
  if (value === undefined || value === null) return null;
  if (typeof value === "number" && isNaN(value)) return null;
  return {
    key,
    value: value.toString(),
  };
};

export const createCustomDimensions = (
  dimensions: Array<[string, string | number | boolean | undefined]>,
): ProductClicked["customDimensions"] => {
  return dimensions
    .map(([key, value]) => createDimension(key, value))
    .filter(
      (dimension): dimension is NonNullable<typeof dimension> =>
        dimension !== null,
    );
};
